const DURACAO_MIN_SEG = 15;
const DURACAO_MAX_SEG = 90;

function brutaSeg(inicioSeg: number, fimSeg: number): number {
  return Math.max(0, fimSeg - inicioSeg);
}

/** Duração da fase de celebração do OverlayAniversario — sempre em [15, 90]s. */
export function calcularDuracaoCelebracaoSeg(inicioSeg: number, fimSeg: number): number {
  return Math.min(DURACAO_MAX_SEG, Math.max(DURACAO_MIN_SEG, brutaSeg(inicioSeg, fimSeg)));
}

/** Fim efetivo do áudio/YT: nunca além do fim configurado nem de 90s de trecho. */
export function calcularFimEfetivoAudioSeg(inicioSeg: number, fimSeg: number): number {
  return inicioSeg + Math.min(brutaSeg(inicioSeg, fimSeg), DURACAO_MAX_SEG);
}
